import React from 'react'
import Countdown, { zeroPad } from 'react-countdown'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

const MaintainCountdown = () => {
	const { t } = useTranslation()
	const today = new Date()
	const deadline = today.setDate(today.getDate() + 3)
	const isDeadline = new Date(deadline).getTime() <= new Date().getTime()
	const renderer = ({ days, hours, minutes, seconds }) => {
		return (
			<>
				<span className="split-number-item">
					<span className="number">{zeroPad(days)}</span>
					<span className="text">D</span>
				</span>
				<span className="split-number-item">
					<span className="number">{zeroPad(hours)}</span>
					<span className="text">H</span>
				</span>
				<span className="split-number-item">
					<span className="number">{zeroPad(minutes)}</span>
					<span className="text">M</span>
				</span>
				<span className="split-number-item">
					<span className="number">{zeroPad(seconds)}</span>
					<span className="text">S</span>
				</span>
			</>
		)
	}

	return (
		<div className="countdown mt-4">
			{isDeadline ? (
				<div className="countdown-wrapper">
					{moment(deadline).format('DD:hh:mm:ss')}
				</div>
			) : (
				<div className="countdown-wrapper split-number">
					<Countdown date={deadline} renderer={renderer} />
				</div>
			)}
		</div>
	)
}

export default MaintainCountdown
